
import { Component, Vue, Inject, Prop, Emit } from 'vue-property-decorator';
import sidebarMenu from './components/sidebarMenu.vue';
import Util from '@/lib/util';

@Component({ components: { sidebarMenu } })
export default class ShrinkableMenu extends Vue {
    name: string = 'shrinkableMenu';
    @Prop({ required: true, type: Array }) menuList: Array<any>;
    @Prop({ type: Array }) openNames: Array<string>;
    @Prop({ type: Function }) beforePush: Function;

    @Prop({
        validator: (val) => {
            return Util.oneOf(val, ['dark', 'light']);
        }
    })
    theme: string;

    get bgColor() {
        return this.theme === 'dark' ? '#001529' : '#fff';
    }

    get tenant() {
        return Util.abp.multiTenancy.getTenantCookie();
    }

    // 商户中心
    get adminUrl() {
        return `https://${this.tenant.tenancyName}.feedeem.com`
    }

    // 是否商家
    get isVendorRole() {
        if (!this.$store.state.session.user) {
            return false;
        }
        return this.$store.state.session.user.roles.includes('Vendor');
    }

    @Emit('on-change')
    handleChange(name: string) {
        let willpush = true;
        if (this.beforePush !== undefined) {
            if (!this.beforePush(name)) {
                willpush = false;
            }
        }
        if (willpush) {
            this.$router.push({ name: name })
        }
    }
}
